import React, { useEffect, useState } from 'react';
import { MdOutlineCalendarToday } from 'react-icons/md';
import { LuCalendarSync } from 'react-icons/lu';
import BasicCard from '../../../../components/basicCard/BasicCard';

import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import weekday from 'dayjs/plugin/weekday';

import { useTranslation } from 'react-i18next';

import TaskLists from './TaskList/TaskLists';
import RecurrentTaskLists from './TaskList/RecurrentTaskLists';
import { usePermissions } from '../../../../hooks/usePermissions';
import CustomTabs from '../../../../components/tabs/CustomTabs';
dayjs.extend(localizedFormat);
dayjs.extend(weekday);

// const timeline: ITimelineItem[] = [
//   {
//     establishment: 'Central Market',
//     location: 'Centre, Tegucigalpa',
//     establishmentType: 'Municipal Market',
//     numberOfProducts: 15,
//     reportLink: '',
//     status: 'completed',
//   },
//   {
//     establishment: 'Supermarket La Colonia',
//     location: 'Centre, Tegucigalpa',
//     establishmentType: 'Supermarket',
//     numberOfProducts: 15,
//     status: 'in progress',
//   },
//   {
//     establishment: 'Pressure The Saving',
//     location: 'Centre, Tegucigalpa',
//     establishmentType: 'Fair',
//     numberOfProducts: 15,
//     status: 'todo',
//   },
// ];

interface TodaysTimelineProps {
  refreshTaskSection?: number;
}

const TodaysTimeline: React.FC<TodaysTimelineProps> = ({ refreshTaskSection }) => {
  const { t } = useTranslation('inspector');

  const { hasPermission } = usePermissions();

  const regularTasks = (
    <>
      <div className="flex flex-col justify-between sm:flex-row">
        {/* <div className="mt-3 w-fit sm:mt-0">
            <DefaultButton handleOnClick={() => {}}>
              <div className="flex flex-row gap-2 font-medium">
                <GrWaypoint />
                Optimize Route
              </div>
            </DefaultButton>
          </div> */}
      </div>

      <div className="my-2 flex flex-col gap-3 md:my-5">
        <TaskLists refreshTaskSection={refreshTaskSection} />
        {/* {timeline.map((item: ITimelineItem) => (
            <div className="rounded-lg border bg-white p-4">
              <div className="flex flex-row items-center justify-between">
                <div className="flex w-full flex-row items-center gap-2 sm:w-fit">
                  <GoClock />
                  {item.startTime} - {item.endTime}
                  <div
                    className={classNames(
                      'ml-4 rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize transition-colors',
                      { 'border-primary bg-primary text-white': item.status === 'completed' },
                      { 'bg-[#f5f5f5] text-black': item.status === 'in progress' }
                    )}
                  >
                    {item.status}
                  </div>
                </div>

                <div>
                  {item.status === 'completed' ? (
                    <FiCheckCircle className="text-xl text-primary-green" />
                  ) : item.status === 'in progress' ? (
                    <VscInfo className="text-xl text-primary" />
                  ) : null}
                </div>
              </div>

              <div className="mt-2 flex flex-row">
                <h5 className="font-semibold text-gray-900">{item.establishment}</h5>
              </div>

              <div className="grid w-full grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3">
                <div className="flex flex-row items-center gap-2">
                  <GeoAlt /> {item.location}
                </div>

                <div className="flex flex-row items-center">
                  {item.numberOfProducts} products to be reviewed.
                </div>

                <div className="text-left md:text-right">
                  {item.status === 'completed' ? (
                    <button className="rounded border p-2">See Report</button>
                  ) : item.status === 'in progress' ? (
                    <button className="rounded border p-2">Continue</button>
                  ) : (
                    <button className="rounded border border-primary bg-primary p-2 text-white">
                      Start
                    </button>
                  )}
                </div>
              </div>

              <div>
                <div
                  className={classNames(
                    'mt-4 inline-flex rounded-full border bg-card-bg-color px-2.5 py-0.5 text-xs font-semibold capitalize sm:mt-0'
                  )}
                >
                  {item.establishmentType}
                </div>
              </div>
            </div>
          ))} */}
      </div>
    </>
  );

  const recurrentTasks = (
    <>
      <div className="my-2 flex flex-col gap-3 md:my-5">
        <RecurrentTaskLists refreshTaskSection={refreshTaskSection} />
      </div>
    </>
  );

  const tabItems = [
    {
      key: '1',
      label: (
        <h4 className="text-md mt-2 flex items-center font-semibold leading-none tracking-tight md:text-2xl">
          <MdOutlineCalendarToday className="mr-1 shrink-0" /> {t('tasks')}
        </h4>
      ),
      children: regularTasks,
    },
    {
      key: '2',
      label: (
        <h4 className="text-md mt-2 flex items-center font-semibold leading-none tracking-tight md:text-2xl">
          <LuCalendarSync className="mr-1 shrink-0" /> {t('recurringTasks')}
        </h4>
      ),
      children: recurrentTasks,
    },
  ];

  // const date = new Date();
  return (
    <BasicCard>
      <div className="px-0 py-4 md:p-4">
        <CustomTabs items={tabItems} defaultActiveKey={'1'} className="inspector-tabs" />
      </div>
    </BasicCard>
  );
};

export default TodaysTimeline;
